// TaskService — migrated to the OpenAPI-generated client.
//
// The server exposes these under the "adminTrainerTask" controller (/admin/tasks/**).
// Pre-migration return shapes preserved: getTasks/getTaskSuggestions/getPendingTaskCount
// returned the raw axios `response` and callers read `res.data` / `res.data.content`, so we
// return `{data}`; create/update/delete/bulk are awaited and also return `{data}`.
// getTasks uses FLAT page/size query params (not a nested Spring Pageable), so it is safe to
// migrate. Auth/timezone come from configureApi's interceptor.
import {
    adminTrainerTaskControllerGetTasks,
    adminTrainerTaskControllerCreate,
    adminTrainerTaskControllerUpdate,
    adminTrainerTaskControllerDelete,
    adminTrainerTaskControllerBulkAction,
    adminTrainerTaskControllerGetSuggestions,
    adminTrainerTaskControllerGetPendingCount,
} from "../api/generated";

const throwAsAxiosError = (error, response) => {
    throw {response: {data: error, status: response?.status}};
};

// Task enums
export const TASK_PRIORITIES = {
    HIGH: 'HIGH',
    MEDIUM: 'MEDIUM',
    LOW: 'LOW'
};

export const TASK_STATUSES = {
    PENDING: 'PENDING',
    COMPLETED: 'COMPLETED'
};

export const TASK_CATEGORIES = {
    CALL: 'CALL',
    FOLLOW_UP: 'FOLLOW_UP',
    PROGRAM_UPDATE: 'PROGRAM_UPDATE',
    PROGRESS_CHECK: 'PROGRESS_CHECK',
    REMINDER: 'REMINDER',
    OTHER: 'OTHER'
};

// Hebrew labels
export const PRIORITY_LABELS = {
    HIGH: 'גבוהה',
    MEDIUM: 'בינונית',
    LOW: 'נמוכה'
};

export const STATUS_LABELS = {
    PENDING: 'ממתין',
    COMPLETED: 'הושלם'
};

export const CATEGORY_LABELS = {
    CALL: 'שיחה',
    FOLLOW_UP: 'מעקב',
    PROGRAM_UPDATE: 'עדכון תוכנית',
    PROGRESS_CHECK: 'בדיקת התקדמות',
    REMINDER: 'תזכורת',
    OTHER: 'אחר'
};

// Priority options for select/dropdown
export const PRIORITY_OPTIONS = [
    { value: TASK_PRIORITIES.HIGH, label: PRIORITY_LABELS.HIGH },
    { value: TASK_PRIORITIES.MEDIUM, label: PRIORITY_LABELS.MEDIUM },
    { value: TASK_PRIORITIES.LOW, label: PRIORITY_LABELS.LOW }
];

// Category options for select/dropdown
export const CATEGORY_OPTIONS = [
    { value: TASK_CATEGORIES.CALL, label: CATEGORY_LABELS.CALL },
    { value: TASK_CATEGORIES.FOLLOW_UP, label: CATEGORY_LABELS.FOLLOW_UP },
    { value: TASK_CATEGORIES.PROGRAM_UPDATE, label: CATEGORY_LABELS.PROGRAM_UPDATE },
    { value: TASK_CATEGORIES.PROGRESS_CHECK, label: CATEGORY_LABELS.PROGRESS_CHECK },
    { value: TASK_CATEGORIES.REMINDER, label: CATEGORY_LABELS.REMINDER },
    { value: TASK_CATEGORIES.OTHER, label: CATEGORY_LABELS.OTHER }
];

export const getTasks = async (page = 0, size = 20, filters = {}) => {
    const {data, error, response} = await adminTrainerTaskControllerGetTasks({
        query: {
            page,
            size,
            ...(filters.status ? {status: filters.status} : {}),
            ...(filters.priority ? {priority: filters.priority} : {}),
            ...(filters.category ? {category: filters.category} : {}),
            ...(filters.keyword ? {keyword: filters.keyword} : {}),
            ...(filters.fromDate ? {fromDate: filters.fromDate} : {}),
            ...(filters.toDate ? {toDate: filters.toDate} : {}),
        },
    });
    if (error) throwAsAxiosError(error, response);
    return {data};
};

export const createTask = async (taskData) => {
    const {data, error, response} = await adminTrainerTaskControllerCreate({body: taskData});
    if (error) throwAsAxiosError(error, response);
    return {data};
};

export const updateTask = async (taskData) => {
    const {data, error, response} = await adminTrainerTaskControllerUpdate({body: taskData});
    if (error) throwAsAxiosError(error, response);
    return {data};
};

export const deleteTask = async (id) => {
    const {data, error, response} = await adminTrainerTaskControllerDelete({path: {id}});
    if (error) throwAsAxiosError(error, response);
    return {data};
};

export const bulkTaskAction = async (taskIds, action) => {
    const {data, error, response} = await adminTrainerTaskControllerBulkAction({
        body: {taskIds, action},
    });
    if (error) throwAsAxiosError(error, response);
    return {data};
};

export const getTaskSuggestions = async () => {
    const {data, error, response} = await adminTrainerTaskControllerGetSuggestions({});
    if (error) throwAsAxiosError(error, response);
    return {data};
};

export const getPendingTaskCount = async () => {
    const {data, error, response} = await adminTrainerTaskControllerGetPendingCount({});
    if (error) throwAsAxiosError(error, response);
    return {data};
};
